"use strict";

import api from "../redux/apis/api";

const ENGINE_GUARDED_COMMAND_TYPES = new Set([
  "power_off",
  "engine_off",
  "engine_stop",
  "relay_off",
  "power_on",
  "engine_on",
  "engine_start",
  "relay_on",
]);

function normalizeRelayPassword(value) {
  const digits = String(value || "").replace(/\D/g, "").slice(-6);
  return digits.length === 6 ? digits : "";
}

export function shouldRequireRelayAccess(options = {}) {
  const commandScope = String(options?.commandScope || "").trim().toLowerCase();
  if (commandScope === "engine_only") return true;

  const initialCommandType = String(options?.initialCommandType || "").trim().toLowerCase();
  return ENGINE_GUARDED_COMMAND_TYPES.has(initialCommandType);
}

export async function verifyRelayAccess(options = {}) {
  if (!shouldRequireRelayAccess(options)) {
    return { ok: true };
  }

  const response = await api.get("/users/settings");
  const relayPassword = normalizeRelayPassword(response?.data?.settings?.relayPassword);

  if (!relayPassword) {
    return { ok: true };
  }

  const enteredPassword = normalizeRelayPassword(
    window.prompt("Enter relay password to open relay controls") || ""
  );

  if (!enteredPassword) {
    return { ok: false, reason: "cancelled", message: "Relay access cancelled." };
  }

  if (enteredPassword !== relayPassword) {
    return {
      ok: false,
      reason: "invalid_password",
      message: "Incorrect relay password. Relay screen was not opened.",
    };
  }

  return { ok: true };
}
